module.exports = __webpack_public_path__ + "static/net1000-498b5b4a22eee7ee3efc5ddda0197e3e.svg";